import {
    STEP_LOGO,
    STEP_PRODUCT_PREFERENCES,
    STEP_PROMOTION,
    TAG_BRANDING_GUIDELINES,
    TAG_BROCHURES,
    TAG_BUSINESS_CARDS,
    TAG_COLORS_FONTS,
    TAG_LOGO,
    TAG_OFFLINE,
    TAG_ONLINE,
    TAG_PRODUCT_LABEL,
    TAG_PRODUCT_PACKAGING,
    TAG_SIGNAGE,
    TAG_SOCIAL_MEDIA,
    TAG_STATIONARY,
    TAG_WEBSITE,
} from './constants';
import type { FilterTags } from './RecommendationEngine';
import type { SelectedValues } from './config';

const promotionToTag = {
    online: { [TAG_ONLINE]: true },
    offline: { [TAG_OFFLINE]: true },
    both: {},
};

const productPreferencesToTag = {
    'colors-fonts': { [TAG_COLORS_FONTS]: true },
    website: { [TAG_WEBSITE]: true },
    'social-media': { [TAG_SOCIAL_MEDIA]: true },
    'brand-guidelines': { [TAG_BRANDING_GUIDELINES]: true },
    brochures: { [TAG_BROCHURES]: true },
    stationery: { [TAG_STATIONARY]: true },
    'product-packaging': { [TAG_PRODUCT_PACKAGING]: true },
    signage: { [TAG_SIGNAGE]: true },
    'product-labels': { [TAG_PRODUCT_LABEL]: true },
    'business-cards': { [TAG_BUSINESS_CARDS]: true },
    other: {},
};

export const mapFilterTags = (selectedValues: SelectedValues) => {
    const {
        [STEP_LOGO]: logo,
        [STEP_PROMOTION]: promotion,
        [STEP_PRODUCT_PREFERENCES]: productPreferences,
    } = selectedValues;

    let filterTags: FilterTags = {
        [TAG_LOGO]: logo === 'logo-required',
    };

    if (promotion !== undefined) {
        filterTags = { ...filterTags, ...promotionToTag[promotion] };
    }

    (productPreferences || []).forEach((preference) => {
        filterTags = {
            ...filterTags,
            ...productPreferencesToTag[preference],
        };
    });

    return filterTags;
};
